class Team {
  constructor() {
    this.id = 0;
    this.wpid = 0;
    this.ssid = 0;
    this.title = '';
    this.shortTitle = '';
    this.subtitle = '';
    this.mascot = '';
    this.gender = '';
    this.slug = '';
    this.url = '';
    this.shortUrl = '';
    this.level = '';
    this.logo = '';
    this.logoHTML = '';
    this.league = '';
    this.address = {
      country: '',
      city: '',
      region: '',
      lat: '',
      lon: '',
    };
    this.score = 0;
    this.status = '';
    this.organizationId = 0;
    this.sport = '';
    this.squads = [];
  }

  getId() {
    return this.id;
  }

  setId(id) {
    this.id = id;

    return this;
  }

  getWpid() {
    return this.wpid;
  }

  setWpid(wpid) {
    this.wpid = wpid;

    return this;
  }

  getSsId() {
    return this.ssid;
  }

  setSsId(ssid) {
    this.ssid = ssid;

    return this;
  }

  hasSsId() {
    return this.getSsId();
  }

  getTitle() {
    return this.title;
  }

  setTitle(title) {
    this.title = title;

    return this;
  }

  getShortTitle() {
    return this.shortTitle;
  }

  setShortTitle(title) {
    this.shortTitle = title;

    return this;
  }

  getSubtitle() {
    return this.subtitle;
  }

  setSubtitle(subtitle) {
    this.subtitle = subtitle;

    return this;
  }

  hasSubtitle() {
    return !! this.getSubtitle();
  }

  getMascot() {
    return this.mascot;
  }

  setMascot(mascot) {
    this.mascot = mascot;

    return this;
  }

  getGender() {
    return this.gender;
  }

  setGender(gender) {
    this.gender = gender;

    return this;
  }

  hasGender() {
    return this.getGender();
  }

  getSlug() {
    return this.slug;
  }

  setSlug(slug) {
    this.slug = slug;

    return this;
  }

  hasSlug() {
    return this.getSlug();
  }

  getUrl() {
    return this.url;
  }

  setUrl(url) {
    this.url = url;

    return this;
  }

  hasUrl() {
    return this.url.length > 0;
  }

  getLevel() {
    return this.level;
  }

  setLevel(level) {
    this.level = level;

    return this;
  }

  hasLevel() {
    return this.getLevel().length > 0;
  }

  getLogo() {
    return this.logo;
  }

  setLogo(logo) {
    this.logo = logo;

    return this;
  }

  hasLogo() {
    return this.getLogo().length > 0;
  }

  getLogoHTML() {
    return this.logoHTML;
  }

  setLogoHTML(html) {
    this.logoHTML = html;

    return this;
  }

  hasLogoHTML() {
    return this.getLogoHTML().length > 0;
  }

  getLeague() {
    return this.league;
  }

  setLeague(league) {
    this.league = league;

    return this;
  }

  hasLeague() {
    return this.getLeague().length > 0;
  }

  getAddress() {
    return this.address;
  }

  setAddress(address) {
    this.address = address;

    return this;
  }

  hasAddress() {
    return this.getAddress();
  }

  getScore() {
    return this.score;
  }

  setScore(score) {
    this.score = score;

    return this;
  }

  getStatus() {
    return this.status;
  }

  setStatus(status) {
    this.status = status;

    return this;
  }

  getOrganizationId() {
    return this.organizationId;
  }

  setOrganizationId(organizationId) {
    this.organizationId = organizationId;

    return this;
  }

  getSport() {
    return this.sport;
  }

  setSport(sport) {
    this.sport = sport;

    return this;
  }

  hasSport() {
    return this.getSport();
  }

  getSquads() {
    return this.squads;
  }

  setSquads(squads) {
    this.squads = squads;

    return this;
  }

  hasSquads() {
    return this.getSquads().length > 0;
  }
}

export default Team;
